import { useMutation, useQueryClient } from '@tanstack/react-query';
import { approvePcmpProposalCorrection } from '../api/pcmpProposals.api';
import { PCMP_CORRECTION_ACTION_COPY } from '../constants/pcmpCorrection.constants';
import type { PcmpCorrectionApprovePayload } from '../types/pcmpCorrection.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

/** Approve the correction: the payment goes to Accounts for re-disbursement. */
export function useApprovePcmpProposalCorrection(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpCorrectionApprovePayload) =>
      approvePcmpProposalCorrection(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, PCMP_CORRECTION_ACTION_COPY.APPROVE.toast, onSuccess),
  });
}
